import { StylesConfig, GroupBase } from 'react-select';
import * as Colors from '../../constants/Colors';
import { rgba } from 'polished';

export const getStyles = <Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(
    height?: string,
    fontSize?: string,
    optionHeight?: string,
    dropDownIndicatorWidth?: string,
    closeIndicatorWidth?: string,
    isInvalid?: boolean,
    minHeight?: string
): StylesConfig<Option, IsMulti, Group> => ({
    container: (provided) => ({
        ...provided,
        width: '100%',
        '&:focus': {
            boxShadow: '0px 0px 4px 0px #8EDCFF',
        },
    }),
    control: (provided, state) => ({
        ...provided,
        height: height ?? '48px',
        minHeight: minHeight ?? '48px',
        border: isInvalid
            ? `1px solid ${Colors.pink}`
            : state.selectProps.menuIsOpen
            ? `1px solid ${Colors.darkBlue}`
            : `1px solid ${Colors.grey}`,
        borderBottom: isInvalid ? '' : state.selectProps.menuIsOpen ? 0 : `1px solid ${Colors.grey}`,
        borderBottomRightRadius: state.selectProps.menuIsOpen ? 0 : '4px',
        borderBottomLeftRadius: state.selectProps.menuIsOpen ? 0 : '4px',
        boxShadow: state.selectProps.menuIsOpen && !isInvalid ? '0px 0px 4px 0px #8EDCFF' : 'none',
        '&:hover': {
            border: isInvalid ? `1px solid ${Colors.pink}` : '',
        },
        '&:focus-within': {
            boxShadow: isInvalid ? `0 0 0 0.1rem ${rgba(Colors.pink50, 0.25)}` : '',
        },
    }),
    valueContainer: (provided) => ({
        ...provided,
        height: '100%',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: Colors.darkGrey,
        fontSize: fontSize ?? '18px',
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: Colors.blue50,
        border: `solid 1px ${Colors.blue50}`,
        borderRadius: '4px',
        padding: '0px 4px',
        color: Colors.black,
        fontSize: fontSize ?? '18px',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        border: `solid 1px transparent`,
        color: Colors.black,
        paddingLeft: '0px',
        paddingRight: '0px',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    }),
    input: (provided) => ({
        ...provided,
        color: Colors.darkGrey,
        fontSize: fontSize ?? '18px',
    }),
    option: (provided, state) => ({
        ...provided,
        display: 'flex',
        padding: '5px',
        color: Colors.darkGrey,
        fontSize: fontSize ?? '18px',
        height: optionHeight ?? '58px',
        background: state.isFocused
            ? state.selectProps.isMulti
                ? Colors.blue10
                : Colors.blue5
            : state.isSelected
            ? Colors.blue10
            : 'transparent',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: Colors.darkGrey,
        fontSize: fontSize ?? '18px',
    }),
    menu: (provided, state) => {
        return {
            ...provided,
            top: 'auto',
            margin: 0,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            border: state.selectProps.menuIsOpen ? `1px solid ${Colors.darkBlue}` : `1px solid ${Colors.grey}`,
            boxShadow: state.selectProps.menuIsOpen ? '1px 1px 1px #8edcff, -1px 1px 1px #8edcff' : 'none',
            borderTop: 0,
        };
    },
    menuList: (provided) => ({
        ...provided,
        padding: 0,
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        height: 'auto',
    }),
    noOptionsMessage: () => ({
        padding: 0,
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        width: dropDownIndicatorWidth ? dropDownIndicatorWidth : 'auto',
        height: '100%',
        alignItems: 'center',
        padding: '8px 4px',
    }),
    clearIndicator: (provided) => ({
        ...provided,
        width: closeIndicatorWidth ? closeIndicatorWidth : 'auto',
        height: '100%',
        alignItems: 'center',
        padding: '8px 4px',
    }),
    group: (provided) => ({
        ...provided,
        paddingBottom: 0,
        paddingTop: '12px',
        borderBottom: `2px dotted ${Colors.darkBlue}`,
    }),
    groupHeading: (provided) => ({
        ...provided,
        fontSize: fontSize ?? '18px',
    }),
});
